import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation, requestUuid, data, errors, extensions, exception) {
        return new.target.h44(operation, requestUuid, data, errors, extensions, exception);
      }
      static h44(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.z43_1 = operation;
        $this.a44_1 = requestUuid;
        $this.b44_1 = data;
        $this.c44_1 = errors;
        $this.d44_1 = extensions;
        $this.e44_1 = exception;
        $this.f44_1 = Companion_getInstance().p42_1;
        $this.g44_1 = false;
        return $this;
      }
      static i44(operation, requestUuid) {
        return this.h44(operation, requestUuid, null, null, null, null);
      }
      j44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.f44_1 = this.f44_1.k44(executionContext);
        return this;
      }
      l44(data) {
        // Inline function 'kotlin.apply' call
        this.b44_1 = data;
        return this;
      }
      m44(errors) {
        // Inline function 'kotlin.apply' call
        this.c44_1 = errors;
        return this;
      }
      n44(exception) {
        // Inline function 'kotlin.apply' call
        this.e44_1 = exception;
        return this;
      }
      f43(extensions) {
        // Inline function 'kotlin.apply' call
        this.d44_1 = extensions;
        return this;
      }
      q42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.a44_1 = requestUuid;
        return this;
      }
      o44(isLast) {
        // Inline function 'kotlin.apply' call
        this.g44_1 = isLast;
        return this;
      }
      v39() {
        var tmp1_operation = this.z43_1;
        var tmp2_requestUuid = this.a44_1;
        var tmp3_data = this.b44_1;
        var tmp4_executionContext = this.f44_1;
        var tmp0_elvis_lhs = this.d44_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.c44_1;
        var tmp7_exception = this.e44_1;
        var tmp8_isLast = this.g44_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.p44_1 = requestUuid;
        this.q44_1 = operation;
        this.r44_1 = data;
        this.s44_1 = errors;
        this.t44_1 = exception;
        this.u44_1 = extensions;
        this.v44_1 = executionContext;
        this.w44_1 = isLast;
      }
      x44() {
        var tmp;
        if (this.l45()) {
          throw ApolloGraphQLException().k45(first(ensureNotNull(this.s44_1)));
        } else if (!(this.t44_1 == null)) {
          throw DefaultApolloException().d45('An exception happened', this.t44_1);
        } else {
          tmp = this.y44();
        }
        return tmp;
      }
      y44() {
        var tmp0_elvis_lhs = this.r44_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().q45(this.t44_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      l45() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.s44_1;
        return !(this_0 == null || this_0.n1());
      }
      x43() {
        return Builder().h44(this.q44_1, this.p44_1, this.r44_1, this.s44_1, this.u44_1, this.t44_1).j44(this.v44_1).o44(this.w44_1);
      }
      toString() {
        var tmp = 'operationName=' + this.q44_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.r44_1 == null ? 'null' : this.q44_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.s44_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.t44_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.t44_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
